export default __webpack_public_path__ + "static/Newark_Penn_Station_June_2015_001-45316e4c6b74379546e2e9ea58c77dd0.webp";